<!-- events金泰展示 -->
<template>
    <div class="EventsListWrap EventsStaticShow">
      <div
        class="EventsList"
        v-for="(subevent, index) in subeventList"
        :key="index">
        <div class="MediaIndex">
          <span v-if="subevent.segmentId == 1">{{ subevent.SerialNumber }}</span>
        </div>
        <!-- Segments -->
        <div class="Title-item SegmentsName">
          <div class="GxtScte"
            @click="SelectTakeElement(subevent)"
            :class="{'SelectTakeElement': subevent.id == TakeElementObj.id, 'LiveElement': subevent.id == TakeElementObj.selectId && TakeElementObj.switch}" v-if="!((subevent.segmentId == 2 || subevent.segmentId == 11) && subevent.eventOperationType == 'Underplay Block' && subevent.UnderplayClip == 0)">
           {{SegmentsTypeShow(subevent.segmentId)}}
          </div>
        </div>
        <!-- Event -->
        <div class="Title-item">
          <div class="GxtScte fileSelete"  v-if="!((subevent.segmentId == 2 || subevent.segmentId == 11) && subevent.eventOperationType == 'Underplay Block' && subevent.UnderplayClip == 0)">
           {{subevent.eventOperationType}}
          </div>
        </div>
        <!-- File -->
        <div class="Title-item FilePicker">
          <div class="referenceName" style="font-size:14px" v-if="subevent.segmentId==1">
            {{eventDetail.liveStatus == 1 ? bePlayingSource.fileName : eventDetail.tname}}
          </div>
          <div
            class="referenceName"
            style="font-size:14px"
            v-else> {{ subevent.fileName }} </div>
        </div>
        <!-- Timing-In -->
        <div class="Title-item">
          <div class="SecondaryOffset" v-if="subevent.segmentId == 13">{{formatSeconds(subevent.OffsetIn)}}</div>
          <div class="SecondaryOffset" v-if="!IsHoldEvents" v-show="subevent.segmentId != 13">{{subevent.ShowTimingIn}}</div>
        </div>
        <!-- Timing-Out -->
        <div class="Title-item">
          <div class="SecondaryOffset"  v-if="subevent.segmentId == 13 && subevent.eventOperationType != 'SCTE'">{{formatSeconds(subevent.OffsetOut)}}</div>
          <div class="SecondaryOffset"  v-if="!IsHoldEvents" v-show="subevent.segmentId != 13">{{subevent.ShowTimingOut}}</div>
        </div>
        <!-- Duration -->
        <div class="Title-item">
          <div class="Duration" v-if="!((subevent.segmentId == 13 && subevent.eventOperationType == 'SCTE') || (IsHoldEvents && subevent.segmentId == 1))">
            {{ calculateInterval(subevent.accumulatedProgramTiming) }}
          </div>
        </div>
        <div class="LiveEventItem" v-if="CurrentPlayoutEvent && CurrentPlayoutEvent == subevent.eventTemplateId"></div>
      </div>
    </div>
</template>

<script>
import Outil from '@/assets/js/utils.js'
export default {
  props: {
    // 选中的事件
    subeventList: {
      type: Array,
      default: () => ([])
    },
    // 当前正在播放的event
    CurrentPlayoutEvent: {
      type: String,
      default: ''
    },
    // 正在播放的源
    bePlayingSource: {
      type: Object,
      default: () => ({
        tpeerid: '',
        fileName: ''
      })
    },
    // 事件的详细信息
    eventDetail: {
      type: Object,
      default: () => ({})
    },
    // 是否HoldEvent模式事件
    IsHoldEvents: {
      type: Boolean,
      default: false
    },
    // 选择的子事件以及开关
    TakeElementObj: {
      type: Object,
      default: () => ({
        switch: false,
        id: '',
        selectId: '',
        message: {}
      })
    },
    // segments类型
    SegmentsType: {
      type: Array,
      default: () => ([])
    }
  },
  data () {
    return {

    }
  },
  created () {

  },
  mounted () {

  },
  methods: {
    // 子事件类型转换
    SegmentsTypeShow (segmentId) {
      let SegmentsName = segmentId
      this.SegmentsType.forEach((item) => {
        if (item.value == segmentId) {
          SegmentsName = item.key
        }
      })
      return SegmentsName
    },
    // 选择子事件
    SelectTakeElement (subevent) {
      this.$emit('SelectTakeElement', subevent)
    },
    // 偏移量时间转换
    formatSeconds (time) {
      time = Math.ceil(time / 1000)
      return Outil.formatSecondsChange(time)
    },
    // 计算分秒小时
    calculateInterval (time) {
      if (typeof time == 'number') {
        let hour = Math.floor(time / (60 * 60 * 1000))
        let minute = Math.floor((time % (60 * 60 * 1000)) / (60 * 1000))
        let second = Math.floor((time % (60 * 1000)) / 1000)
        hour = hour ? `${hour}h` : ''
        minute = minute ? `${minute}m` : ''
        second = second ? `${second}s` : ''
        return hour + minute + second
      } else {
        return ''
      }
    }
  }
}
</script>

<style scoped lang="less">
.EventsStaticShow {
  .EventsList {
    .Title-item {
      font-size: 14px;
      color: #DBDBDB;
    }
    .SegmentsName{
      .GxtScte {
        width: 110px;
        height: 32px;
        background: #444444;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding: 0px 5px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        cursor: pointer;
      }
      .SelectTakeElement {
        border: 2px solid #33AB4F;
      }
      .LiveElement{
        border: 2px solid #E56464;
      }
    }
  }
}
</style>
